export default __webpack_public_path__ + "static/media/infographic-coin-success.25ebd887.svg";